import axios from 'axios';

const version = '/api/v1';

export async function checkInvite(code) {
  const res = await axios({
    method: 'post',
    url: `${version}/org/checkInvite`,
    data: { code },
  });
  return res.data;
}

export async function acceptInvite(code) {
  const res = await axios({
    method: 'post',
    url: `${version}/org/acceptInvite`,
    data: { code },
  });
  return res.data;
}

export async function loginOrRegister({ email, password, code }) {
  const res = await axios({
    method: 'post',
    url: `${version}/user/loginOrRegister`,
    data: { email, password, code },
  });
  return res.data;
}



// WEBPACK FOOTER //
// ./src/store/modules/Invite/api.js